import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services';
import {
  GetGroupLinesConsumptionsAverageParams,
  GetGroupLinesConsumptionsAverageResponse,
  GetGroupLinesConsumptionsDetailedParams,
  GetGroupLinesConsumptionsDetailedResponse,
} from '../usage_predictions.proto';

@Injectable({
  providedIn: 'root',
})
export class UsagePredictionsService {
  constructor(private readonly apiService: ApiService) {}

  getGroupLinesConsumptionsAverage(
    getGroupLinesConsumptionsAverageParams: GetGroupLinesConsumptionsAverageParams
  ): Observable<GetGroupLinesConsumptionsAverageResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getGroupLinesConsumptionsAverageParams
    );
    return this.apiService.get(
      `/v2-internal/groups/${getGroupLinesConsumptionsAverageParams.groupId}/lines-consumptions/average`,
      params
    );
  }

  getGroupLinesConsumptionsDetails(
    getGroupLinesConsumptionsDetailedParams: GetGroupLinesConsumptionsDetailedParams
  ): Observable<GetGroupLinesConsumptionsDetailedResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getGroupLinesConsumptionsDetailedParams
    );
    return this.apiService.get(
      `/v2-internal/groups/${getGroupLinesConsumptionsDetailedParams.groupId}/lines-consumptions`,
      params
    );
  }
}
